import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static targets = ["searchInput"]

  search() {
    clearTimeout(this._searchTimeout)
    this._searchTimeout = setTimeout(() => {
      const q = this.searchInputTarget.value.trim()
      const url = new URL(window.location)
      if (q) {
        url.searchParams.set("q", q)
      } else {
        url.searchParams.delete("q")
      }
      Turbo.visit(url.toString())
    }, 300)
  }
}
